@if(departmentFormReady()) {
    <form autocomplete="off" [formGroup]="departmentForm"
            class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <section class="tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
    
            <div class="tw-col-span-12 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-4 tw-pb-4">
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle formControlName="not_discountable" aria-label="{{'ITEMS.DEPARTMENTS.NOT_DISCOUNTABLE' | translate}}"
                        class="tw-p-3">{{'ITEMS.DEPARTMENTS.NOT_DISCOUNTABLE' | translate}}</mat-slide-toggle>
                </div>
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle formControlName="display" aria-label="{{'ITEMS.DEPARTMENTS.DISPLAY' | translate}}"
                        class="tw-p-3">{{'ITEMS.DEPARTMENTS.DISPLAY' | translate}}</mat-slide-toggle>
                </div>
            </div>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.PRINTER_CODE</mat-label>
                <input matInput formControlName="printer_code" [readonly]="true">
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.CODE</mat-label>
                <input matInput formControlName="code" appTrimInput>
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.PMS_CODE</mat-label>
                <div class="tw-flex">
                    <input matInput formControlName="pms_code" appTrimInput>
                    <mat-icon class="icon-clickable -tw-translate-y-1.5"
                        (click)="selectChainProductsLeanPMS()">fact_check</mat-icon>
                </div>
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.NAME</mat-label>
                <input matInput formControlName="name" appTrimInput>
                <mat-hint [align]="'end'">{{departmentFormService.name?.value?.length || '0'}}
                    / {{departmentFormService.validators.nameMaxLength}}</mat-hint>
                @if(departmentFormService.name?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{departmentFormService.validators.nameMaxLength}})</mat-error>
                } @else if(departmentFormService.name?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-12 lg:tw-col-span-8">
                <mat-label translate>ITEMS.DEPARTMENTS.LAW_REF</mat-label>
                <input matInput formControlName="law_ref" appTrimInput>
                <mat-hint [align]="'end'">{{departmentFormService.law_ref?.value?.length || '0'}}
                    / {{departmentFormService.validators.lawRefMaxLength}}</mat-hint>
                @if(departmentFormService.law_ref?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{departmentFormService.validators.lawRefMaxLength}})</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.VAT</mat-label>
                <mat-select formControlName="vat_id">
                    @for(vat of vats; track vat.id) {
                        <mat-option [value]="vat.id">{{ getVatValue(vat) }}</mat-option>
                    }
                </mat-select> 
                @if(departmentFormService.vat_id?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.SALES_TYPE</mat-label>
                <mat-select formControlName="sales_type">
                    @for(sale of salesTypesList; track sale.value) {
                        <mat-option [value]="sale.value">{{ sale.name | translate}}</mat-option>
                    }
                </mat-select> 
                @if(departmentFormService.sales_type?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.ACTIVITY_CODE</mat-label>
                <mat-select formControlName="activity_code_id">
                    @for(code of activityCodes; track code.id) {
                        <mat-option [value]="code.id">{{code.name}} ({{code.ateco_code}})</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.DEPARTMENTS.GIFT_CARD_TYPE</mat-label>
                <mat-select formControlName="giftcard_type_uuid">
                    @for(type of giftcardsTypesList; track $index) {
                        <mat-option [value]="type.uuid">{{ type.name }}</mat-option>
                    }
                </mat-select> 
                @if(departmentFormService.vat_id?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
        </section>
    </form>
}